import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-save-confirm-dialog',
  templateUrl: 'save-confirm-dialog.html'
})
export class SaveConfirmDialog {

  constructor(
    public dialogRef: MatDialogRef<SaveConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
